import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.container.Forbidden.title',
    defaultMessage: 'Esse usuário não tem acesso à Central da imobiliária',
  },
  description: {
    id: 'app.container.Forbidden.description',
    defaultMessage:
      'Tente acessar com outra conta. Se precisar, entre em contato conosco.',
  },
  contact: {
    id: 'app.container.Forbidden.contact',
    defaultMessage: 'Entrar em contato',
  },
  logout: {
    id: 'app.container.Forbidden.logout',
    defaultMessage: 'Sair da conta',
  },
  back: {
    id: 'app.container.Forbidden.back',
    defaultMessage: 'Voltar para página inicial',
  },
});
